import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_pricing_scheme_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_pricing_scheme_hdr: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  point_ccy_guid: fromDatatype.GuidDataFieldInterface;
  reward_point: fromDatatype.NumericDatatypeInterface;
  reward_point_enable: boolean;
  reward_point_operator: fromDatatype.VarcharDatatypeInterface;
  reward_point_ratio: fromDatatype.NumericDatatypeInterface;
  redeem_point: fromDatatype.NumericDatatypeInterface;
  redeem_point_enable: boolean;
  redeem_point_operator: fromDatatype.VarcharDatatypeInterface;
  redeem_point_ratio: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  validity_duration_in_day: fromDatatype.IntegerDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_selling_list_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_promotion_price: fromDatatype.NumericDatatypeInterface;
  sales_promotion_price_excl_tax : fromDatatype.NumericDatatypeInterface;
  sales_promotion_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_promotion_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  max_qty_per_order: fromDatatype.NumericDatatypeInterface;
  min_qty_per_order: fromDatatype.NumericDatatypeInterface;
  sales_promotion_valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  sales_promotion_valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_check: boolean;
  sales_einvoice_item_classification_guid: fromDatatype.GuidDataFieldInterface;
  sales_einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  sales_einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_item_classification_guid: fromDatatype.GuidDataFieldInterface;
  purchase_einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  purchase_einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
  cash_topup_price: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_mst_pricing_scheme_link_RowClass implements bl_fi_mst_pricing_scheme_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_pricing_scheme_hdr: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_line_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  sales_unit_price: fromDatatype.NumericDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  sales_max_price: fromDatatype.NumericDatatypeInterface;
  sales_min_price: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price: fromDatatype.NumericDatatypeInterface;
  purchase_max_price: fromDatatype.NumericDatatypeInterface;
  purchase_min_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  point_ccy_guid: fromDatatype.GuidDataFieldInterface;
  reward_point: fromDatatype.NumericDatatypeInterface;
  reward_point_enable: boolean;
  reward_point_operator: fromDatatype.VarcharDatatypeInterface;
  reward_point_ratio: fromDatatype.NumericDatatypeInterface;
  redeem_point: fromDatatype.NumericDatatypeInterface;
  redeem_point_enable: boolean;
  redeem_point_operator: fromDatatype.VarcharDatatypeInterface;
  redeem_point_ratio: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  validity_duration_in_day: fromDatatype.IntegerDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  input_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_tax_rate: fromDatatype.NumericDatatypeInterface;
  output_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  output_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  input_wht_tax_type: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_code: fromDatatype.VarcharDatatypeInterface;
  input_wht_tax_rate: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_price_before_discount_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_selling_list_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_promotion_price: fromDatatype.NumericDatatypeInterface;
  sales_promotion_price_excl_tax : fromDatatype.NumericDatatypeInterface;
  sales_promotion_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_promotion_price_wht_tax_amt: fromDatatype.NumericDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  max_qty_per_order: fromDatatype.NumericDatatypeInterface;
  min_qty_per_order: fromDatatype.NumericDatatypeInterface;
  sales_promotion_valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  sales_promotion_valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_check: boolean;
  sales_einvoice_item_classification_guid: fromDatatype.GuidDataFieldInterface;
  sales_einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  sales_einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  sales_einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_item_classification_guid: fromDatatype.GuidDataFieldInterface;
  purchase_einvoice_item_classification_code: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_item_classification_desc: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  purchase_einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  purchase_einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
  cash_topup_price: fromDatatype.NumericDatatypeInterface;
}
